import styled, { css } from 'styled-components';

import { mq, getColor, getSpace } from '../../../stylesheets/tools';

const StyledStakeholder = styled.section`
  position: relative;
  margin-top: ${getSpace('xxl')};
  margin-bottom: ${getSpace('xxl')};

  ${props =>
    props.$hasBackground &&
    css`
      background-color: ${getColor('lightGray')};
      padding: ${getSpace('xl')} 0;

      ${mq('m')} {
        padding: ${getSpace('xxl')} 0;
      }
    `}

  ${mq('m')} {
    margin-top: 128px;
    margin-bottom: 128px;
  }

  h2 {
    text-align: center;
    padding: 0 24px;
    margin-bottom: ${getSpace('xl')};

    ${mq('m')} {
      margin-bottom: ${getSpace('xxl')};
    }
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-wrapper {
    align-items: center;
    transition-timing-function: linear;
    margin-bottom: ${getSpace('l')};
    justify-content: ${props => (props.$isLocked ? 'center' : 'flex-start')};

    ${mq('m')} {
      margin-bottom: ${getSpace('xl')};
    }
  }

  .swiper-slide {
    --aspectRatio: 16 / 9;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 220px;
    height: 100px;
    padding: 0 ${getSpace('m')};
  }

  .swiper-slide img {
    position: relative;
    display: block;
    max-width: 100%;
    max-height: 100%;
    aspect-ratio: var(--aspectRatio);
    object-fit: contain;
  }

  .stakeholder__meta {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getSpace('m')};
    padding: 0 24px;

    ${mq('m')} {
      flex-direction: row;
      gap: ${getSpace('xl')};
    }
  }

  .stakeholder__controls {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: calc(${getSpace('m')} * -1);
      height: 100%;
      width: 2px;
      background: #000;
      display: none;

      ${mq('m')} {
        display: block;
      }
    }
  }

  .stakeholder__button {
    all: unset;
    display: flex;
    align-items: center;
    gap: ${getSpace('xxs')};
    cursor: pointer;

    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      color: ${getColor('white')};
      background: ${getColor('greenTwo')};
    }

    &:focus .stakeholder__button-icon,
    &:hover .stakeholder__button-icon {
      background: ${getColor('black')};
    }

    &-label {
      display: none;

      ${mq('l')} {
        display: block;
      }
    }
  }
`;

export default StyledStakeholder;
